import { render, staticRenderFns } from "./TableTopNns.vue?vue&type=template&id=cdc63008"
import script from "./TableTopNns.vue?vue&type=script&lang=js"
export * from "./TableTopNns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports